import { useContext } from 'react'
import { Modal } from 'antd'
import {
  SalesCodeComplexityContext,
  SET_SHOW_HIDE_FORM_POPUP,
} from '../context/context'
import SalesCodeComplexityForm from './SalesCodeComplexityForm'
import { useIntl } from 'react-intl'

const SalesCodeComplexityFormModal = (props) => {
  const [salesCodeState, salesCodeDispatch] = useContext(SalesCodeComplexityContext)
  const intl = useIntl()

  return (
    <Modal
      title={intl.formatMessage({ id: 'salesCodeComplexity.title' })}
      open={salesCodeState?.showUploadPopup}
      centered={true}
      onCancel={() => {
        salesCodeDispatch({ type: SET_SHOW_HIDE_FORM_POPUP, data: false })
        props.getSalesCodeComplexityData(null, true)
      }}
      width="75%"
      footer={null}
      className='sales-code-complexity-upload'
      destroyOnHidden
    >
      <SalesCodeComplexityForm
        getSalesCodeComplexityData={props.getSalesCodeComplexityData}
      />
    </Modal>
  )
}

export default SalesCodeComplexityFormModal
